
export const formatJsonText = (input) => {
    let formattedInput = input.trim();
    if (formattedInput.startsWith('Log>>>>')) {
        formattedInput = formattedInput.substring('Log>>>>'.length).trim();
    }

    try {
        return JSON.stringify(JSON.parse(formattedInput), null, 4);
    } catch { }

    try {
        let fixedInput = formattedInput
            .replace(/([^}\]"\s])\s*("[a-zA-Z_]\w*"\s*:)/g, '$1,$2')
            .replace(/([{,])\s*([\w$-]+)\s*:/g, '$1"$2":')
            .replace(/:\s*([\w.$-@]+)\s*([,}\]])/g, (match, value, endChar) => {
                if (/^-?\d+(\.\d+)?$/.test(value)) return `:${value}${endChar}`;
                if (/^(true|false|null)$/i.test(value)) return `:${value.toLowerCase()}${endChar}`;
                if (/^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}Z?)?$/.test(value)) return `:"${value}"${endChar}`;
                return `:"${value}"${endChar}`;
            })
            .replace(/:\s*'([^']+)'\s*([,}\]])/g, ':"$1"$2')
            .replace(/([{,])\s*'([\w\s-]+)'\s*:/g, '$1"$2":')
            .replace(/'([^']+)'/g, '"$1"')
            .replace(/,\s*([}\]])/g, '$1')
            .replace(/\[\s*,/g, '[')
            .replace(/,\s*,/g, ',')
            .replace(/,\s*\]/g, ']')
            .trim();

        if (!fixedInput.startsWith("{") && !fixedInput.startsWith("[")) {
            fixedInput = `{${fixedInput}}`;
        }

        return JSON.stringify(JSON.parse(fixedInput), null, 4);
    } catch (e) {
        return manualBeautify(formattedInput);
    }
};

const manualBeautify = (input) => {
    let formatted = '', indentLevel = 0, inString = false;
    input = input.replace(/\s+/g, '');

    for (let i = 0; i < input.length; i++) {
        let char = input[i];
        if (char === '"') inString = !inString;
        if (char === ':' && !inString) formatted += ': ';
        else if (char === ',' && !inString) formatted += ',\n' + '    '.repeat(indentLevel);
        else if ((char === '{' || char === '[') && !inString) formatted += char + '\n' + '    '.repeat(++indentLevel);
        else if ((char === '}' || char === ']') && !inString) formatted += '\n' + '    '.repeat(--indentLevel) + char;
        else formatted += char;
    }

    return formatted.trim();
};
